export const COMMON_CHANNELS_ARTICLE_ID = 'A-256';
